import React from 'react'

import Layout from 'components/Layout'
import PriceLevelsComponent from 'components/PriceLevels'
import ListFilters from 'components/PriceLevels/ListFilters'

const PriceLevels = () => (
  <Layout
    isSidebar
    navbarContent={<ListFilters />}
    mainContent={<PriceLevelsComponent />}
  />
)

export default PriceLevels
